import type { ApiError, LegacyApiError } from '@omnipresentgroup/api';
import { Button, Card, ContentState } from '@omnipresentgroup/design-system';
import type { FallbackRender } from '@sentry/react';

import { ERROR_STATE_DESC, ERROR_STATE_TITLE } from '../../constants';
import { WrappedMixpanel } from '../../mixpanelWrapper';

export const ErrorBoundaryFallback: FallbackRender = ({
  error,
  resetError,
}) => {
  return (
    <Card p="4">
      <ContentState
        id="error-boundary-state"
        variant="error"
        title={ERROR_STATE_TITLE}
        description={
          (error as ApiError | LegacyApiError).detail || ERROR_STATE_DESC
        }
        callToAction={
          <Button
            onClick={() => {
              WrappedMixpanel.track('Retry Clicked');
              resetError?.();
            }}
          >
            Retry
          </Button>
        }
      />
    </Card>
  );
};
